import React, { useContext, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import { AuthContext } from "../context/AuthContext";
import { PreferencesContext } from "../context/PreferencesContext";

const TopBar = () => {
  const { logout, user } = useContext(AuthContext);
  const {
    organization,
    orgDisplayName,
    academicYear,
    yearDisplayName,
    orgOptions,
    handleOrgChange,
  } = useContext(PreferencesContext);

  return (
    <AppBar position="fixed" sx={{ zIndex: 1201 }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          JASS Store ERP
        </Typography>
        {user && (
          <>
            <Typography sx={{ mr: 2 }}>{user.name}</Typography>
            {user.role === "super_admin" ? (
              <Select
                value={organization}
                onChange={(e) => handleOrgChange(e.target.value)}
                size="small"
                sx={{ mr: 2, bgcolor: "white", color: "black" }}
              >
                {orgOptions.map((org) => (
                  <MenuItem key={org._id} value={org._id}>
                    {org.name}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <Typography sx={{ mr: 2 }}>{orgDisplayName}</Typography>
            )}
            {academicYear && (
              <Typography sx={{ mr: 2 }}>{yearDisplayName}</Typography>
            )}
            <Button color="inherit" onClick={logout}>
              Logout
            </Button>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
